module.exports = __webpack_public_path__ + "img/gear.a8bf73e5.png";